import axios from 'axios';

// En producción, REACT_APP_API_URL = "https://novasolutions.ddns.net/api/transiapp"
// El proxy de Apache convierte /api/transiapp → localhost:5058
// Las rutas del código ya incluyen /api/... así que la URL final correcta es:
// https://novasolutions.ddns.net/api/transiapp + /api/auth/login
// → Apache reenvía como: localhost:5058/api/auth/login ✅
//
export const API_URL = process.env.REACT_APP_API_URL || `http://${window.location.hostname}:5058`;

const instance = axios.create({
  baseURL: API_URL
});

// Configurar interceptor para incluir el token si existe
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    // Filtro global de concesionario (usuarios con varios concesionarios asignados)
    const filtro = localStorage.getItem('concesionario_filtro');
    if (filtro && filtro !== 'todos') {
      config.headers['X-Concesionario-Filtro'] = filtro;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default instance;
